import "@fortawesome/fontawesome-free/css/all.css";
import Vue from "vue";
import Vuetify from "vuetify/lib";
Vue.use(Vuetify);
export default new Vuetify({
  icons: {
    iconfont: "fa"
  },
  theme: {
    disable: true
  }
});